import { z } from "zod";

/**
 * Canonical provider name surfaced for Inference.net's own serverless models.
 * Shared so the backend catalog and frontend display agree on the literal.
 */
export const INFERENCE_NET_PROVIDER_NAME = "Inference.net";

export const MODEL_CATALOG_SURFACES = ["catalog", "playground"] as const;

export const ModelCatalogSurfaceSchema = z.enum(MODEL_CATALOG_SURFACES);

export type ModelCatalogSurface = (typeof MODEL_CATALOG_SURFACES)[number];

export const MODEL_CATALOG_CACHE_VERSION = "v12";

export const MODEL_CATALOG_CACHE_SECONDS = {
  publicEdge: 5 * 60,
  // Price-affecting mutations delete public catalog keys. A stale refresh that
  // started before the commit could otherwise rewrite the old price after the
  // delete and extend staleness for 30 minutes. Keep normal fresh caching, but
  // force an origin reload after expiry/invalidation instead of serving stale.
  publicStaleWhileRevalidate: 0,
  teamPrivate: 60,
  teamStaleWhileRevalidate: 5 * 60,
} as const;
